import React from 'react';
export function SystemIntro() {
  return <div id="sistema" className="mx-auto max-w-[880px] px-5 pt-20 text-center sm:px-8 sm:pt-24" style={{
    paddingTop: "36px"
  }} data-id="element-178" data-mp="2bkxce4qygbju">
      
      <h2 className="mt-4 text-balance font-display text-[2.1rem] leading-[1.08] text-petrol sm:text-5xl" data-id="element-179" data-mp="238vis2x4jtc9">
        Conoce <em className="text-terra" data-id="element-180" data-mp="288hwseks1dm4">Megapack Maestro de Sesiones™</em>
      </h2>
      <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink-soft" data-id="element-181" data-mp="1bhpfjdm3xfir">
        Es una biblioteca profesional organizada para consultar rápidamente estructuras, preguntas, diálogos e intervenciones orientativas, y adaptarlas a cada sesión.
      </p>
      <p className="mt-8 font-display text-3xl text-petrol sm:text-4xl" data-id="element-182" data-mp="1kgt06m0xa2zd">
        Consulta. <em className="text-sage-deep" data-id="element-183" data-mp="1piifidv6h2t9">Adapta.</em> <em className="text-terra" data-id="element-184" data-mp="1pf49mvnb2bh2">Prepara.</em>
      </p>
    </div>;
}